import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import Ionicons from 'react-native-vector-icons/Ionicons';
import {SvgUri} from 'react-native-svg';
import {getBottomSpace, isIphoneX} from 'react-native-iphone-screen-helper';

export const Container = styled.View`
  flex: 1;
`;

export const Content = styled.View`
  padding: 0 24px;
  flex: 1;
`;

export const IllustrationContainer = styled.View`
  justify-content: center;
  align-items: center;
`;

export const Illustration = styled(SvgUri)`
  text-align: center;
`;

export const TitleContent = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  margin-top: ${RFValue(16)}px;
  margin-bottom: ${RFValue(12)}px;
  text-align: center;
`;

export const Description = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  text-align: center;
`;

export const InputGroup = styled.View`
  flex-direction: row;
  justify-content: space-between;
  background: ${({theme}) => theme.colors.input_search};
  align-items: center;
  margin-top: ${RFValue(40)}px;
  border-radius: ${RFValue(8)}px;
`;

export const Input = styled.TextInput`
  font-family: ${({theme}) => theme.fonts.medium};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
  flex: 1;
  padding-left: ${RFValue(20)}px;
  height: ${RFValue(50)}px;
`;

export const CopyButton = styled.TouchableOpacity`
  height: ${RFValue(50)}px;
  padding: 0 ${RFValue(20)}px;
  align-items: center;
  justify-content: center;
`;

export const CopyButtonContainer = styled.View`
  flex-direction: row;
  justify-content: flex-end;
  margin-top: ${RFValue(12)}px;
`;

export const CopyButtonText = styled.TouchableOpacity`
  border-style: solid;
  border-color: ${({theme}) => theme.colors.blue};
  border-bottom-width: 2px;
`;

export const CopyText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(12)}px;
`;

export const Icon = styled(Ionicons)`
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(15)}px;
`;

export const Footer = styled.View`
  padding: ${!isIphoneX() ? RFValue(20) : 0}px 24px;
`;
